import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pickFirst'
})
export class PickFirstPipe implements PipeTransform {

  transform(value: string[], defaultValue: string|null = null): string|null {
    if (!Array.isArray(value) || value.length === 0)
      return defaultValue;

    return value[0];
  }
}